import { render, staticRenderFns } from "./AddOnsPicker.vue?vue&type=template&id=e59edfde&scoped=true"
import script from "./AddOnsPicker.vue?vue&type=script&lang=js"
export * from "./AddOnsPicker.vue?vue&type=script&lang=js"
import style0 from "./AddOnsPicker.vue?vue&type=style&index=0&id=e59edfde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59edfde",
  null
  
)

export default component.exports